import { lazy } from "react";
import { IRouteDefinition, ISubModuleRoutes } from "../routing";
import { Location } from "history";

const FrontPage = lazy(() => import(/* webpackChunkName: 'DokumentitApp_FrontPage' */"./tyoluvat/views/FrontPage"));
const PermitPageRouter = lazy(() => import(/* webpackChunkName: 'DokumentitApp_PermitPageRouter' */"./tyoluvat/views/PermitPage/PermitPage"));
const PermitsListPage = lazy(() => import(/* webpackChunkName: 'DokumentitApp_PermitsListPage' */"./tyoluvat/views/PermitsListPage"))
const PermitArchivePage = lazy(() => import(/* webpackChunkName: 'DokumentitApp_PermitArchivePage' */"./tyoluvat/views/PermitArchivePage"))

const MapPage = lazy(() => import(/* webpackChunkName: 'DokumentitApp_PermitMapPage' */"./tyoluvat/views/MapPage"))
const EditPermitPage = lazy(() => import(/* webpackChunkName: 'DokumentitApp_EditPermitPage' */"./tyoluvat/views/EditPermitPage"))
const InitializePermitPage = lazy(() => import(/* webpackChunkName: 'DokumentitApp_InitializePermitPage' */"./tyoluvat/views/InitializePermitPage"))
const CopyPermitPage = lazy(() => import(/* webpackChunkName: 'DokumentitApp_CopyPermitPage' */"./tyoluvat/views/CopyPermitPage"))
const NewPermitPage = lazy(() => import(/* webpackChunkName: 'DokumentitApp_NewPermitPage' */"./tyoluvat/views/NewPermitPage"))

const PermitCreatedPage = lazy(() => import(/* webpackChunkName: 'DokumentitApp_PermitCreatedPage' */"./tyoluvat/views/PermitCreatedPage"))
const PermitPrintPage = lazy(() => import(/* webpackChunkName: 'DokumentitApp_PermitPrintPage' */"./tyoluvat/views/PermitPrintPage"))
const AnonymousPermitPage = lazy(() => import(/* webpackChunkName: 'DokumentitApp_AnonymousPermitPage' */"./tyoluvat/views/AnonymousPermitPage"))
const AnonymousPermitApprovalPage = lazy(() => import(/* webpackChunkName: 'DokumentitApp_AnonymousPermitApprovalPage' */"./tyoluvat/views/AnonymousPermitApprovalPage"))

export const TYOLUVAT_APP_PREFIX = "dokumentit"


export enum DokumentitRouteId {
    FrontPage = "dokumentit-front-page",
    ListPage = "dokumentit-list-page",
    MapPage = "dokumentit-map-page",
    ArchivePage = "dokumentit-archive-page",
    InitializePermitPage = "dokumentit-open-form-page",
    NewPermitPage = "dokumentit-new-document-page",

    DocumentPage = "dokumentit-page",
    PermitHistoryPage = "dokumentit-document-history-page",
    PermitTasksPage = "dokumentit-document-tasks-page",
    PermitEventLog = "dokumentit-document-event-log-page",
    PermitEventPage = "dokumentit-document-event-page",
    PermitStatusChangePage = "dokumentit-document-status-change-page",
    PermitTaskPage = "dokumentit-document-task-detail-page",
    PermitTaskFormPage = "dokumentit-document-task-form-page",
    PermitManualControl = "dokumentit-document-task-manual-control",


    PermitCreatedPage = "dokumentit-document-created-page",
    CopyPermitPage = "dokumentit-document-copy-page",
    PermitPrint = "dokumentit-document-print-page",
    AnonymousPermit = "dokumentit-anonymous-document-page",
    AnonymousPermitApproval = "dokumentit-anonymous-document-approval-page",
    EditPermitPage = "dokumentit-edit-document-page",
    TyoluvatPageNotFoundPage = "dokumentit-page-not-found"

};

const makeRelativeTyoluvatPath = (path: string) => {
    return `/:configurationReference${path}`
};

export const getTyoluvatPathContext = (location: Location): { tenantReference: string; appPrefix: string; configurationReference: string } => {
    const pathParts = location.pathname.split("/");
    const appPrefixIndex = pathParts.indexOf(TYOLUVAT_APP_PREFIX);
    const isHostedOnMultitenantFolderStructure = appPrefixIndex > 0;

    if (isHostedOnMultitenantFolderStructure) {
        const [tenantReference, appPrefix, configurationReference] = pathParts;
        return { tenantReference, appPrefix, configurationReference };
    };

    const configurationReference = pathParts[appPrefixIndex + 1];
    return { tenantReference: "", configurationReference, appPrefix: pathParts[0] };
};

export const tyoluvatRoutes: IRouteDefinition[] = [
    {
        id: DokumentitRouteId.FrontPage,
        exact: true,
        path: makeRelativeTyoluvatPath("/"),
        component: FrontPage
    },

    {
        id: DokumentitRouteId.ListPage,
        exact: true,
        path: makeRelativeTyoluvatPath("/lista"),
        component: PermitsListPage
    },

    {
        id: DokumentitRouteId.ArchivePage,
        exact: true,
        path: makeRelativeTyoluvatPath("/arkisto"),
        component: PermitArchivePage
    },

    {
        id: DokumentitRouteId.MapPage,
        exact: true,
        path: makeRelativeTyoluvatPath("/kartta"),
        component: MapPage
    },

    {
        id: DokumentitRouteId.DocumentPage,
        exact: true,
        path: makeRelativeTyoluvatPath("/lista/:permit/tiedot"),
        component: PermitPageRouter
    },

    {
        id: DokumentitRouteId.PermitEventLog,
        exact: true,
        path: makeRelativeTyoluvatPath("/lista/:permit/tapahtumat"),
        component: PermitPageRouter
    },

    {
        id: DokumentitRouteId.PermitEventPage,
        exact: true,
        path: makeRelativeTyoluvatPath("/lista/:permit/tapahtumat/:event"),
        component: PermitPageRouter
    },

    {
        id: DokumentitRouteId.PermitStatusChangePage,
        exact: true,
        path: makeRelativeTyoluvatPath("/lista/:permit/tilanvaihto"),
        component: PermitPageRouter
    },

    {
        id: DokumentitRouteId.PermitTaskPage,
        exact: true,
        path: makeRelativeTyoluvatPath("/lista/:permit/tehtavat/:task/tiedot"),
        component: PermitPageRouter
    },

    {
        id: DokumentitRouteId.PermitTaskFormPage,
        exact: true,
        path: makeRelativeTyoluvatPath("/lista/:permit/tehtavat/:task/lomake"),
        component: PermitPageRouter
    },

    {
        id: DokumentitRouteId.PermitTasksPage,
        exact: false,
        path: makeRelativeTyoluvatPath("/lista/:permit/tehtavat"),
        component: PermitPageRouter
    },


    {
        id: DokumentitRouteId.EditPermitPage,
        exact: true,
        path: makeRelativeTyoluvatPath("/muokkaa/dokumentti_:permit"),
        component: EditPermitPage
    },


    {
        id: DokumentitRouteId.InitializePermitPage,
        exact: true,
        path: makeRelativeTyoluvatPath("/uusi-dokumentti/:formType"),
        component: InitializePermitPage
    },


    {
        id: DokumentitRouteId.CopyPermitPage,
        exact: true,
        path: makeRelativeTyoluvatPath("/uusi-dokumentti/:formType/:basePermit"),
        component: CopyPermitPage
    },


    {
        id: DokumentitRouteId.NewPermitPage,
        exact: true,
        path: makeRelativeTyoluvatPath("/lomake/:formType"),
        component: NewPermitPage
    },



    {
        id: DokumentitRouteId.PermitCreatedPage,
        exact: true,
        path: makeRelativeTyoluvatPath("/valmis/:formType/:permit"),
        component: PermitCreatedPage
    },


    //
    //  Anonymous routes
    //

    {
        id: DokumentitRouteId.PermitPrint,
        requireAuth: false,
        exact: true,
        path: makeRelativeTyoluvatPath("/tulosta/dokumentti/:package"),
        component: PermitPrintPage
    },

    {
        id: DokumentitRouteId.AnonymousPermit,
        requireAuth: false,
        exact: true,
        path: makeRelativeTyoluvatPath("/anonyymi/dokumentti/:package"),
        component: AnonymousPermitPage
    },

    {
        id: DokumentitRouteId.AnonymousPermit,
        requireAuth: false,
        exact: true,
        path: makeRelativeTyoluvatPath("/anonyymi/kuittaus/:package/:approvalGuid"),
        component: AnonymousPermitApprovalPage
    },

    {
        id: DokumentitRouteId.TyoluvatPageNotFoundPage,
        exact: false,
        requireAuth: false,
        path: makeRelativeTyoluvatPath(""),
        component: lazy(() => import(/* webpackChunkName: 'NotFound' */"./tyoluvat/views/SelectConfiguration"))
    }

];




const DokumentitRouting: ISubModuleRoutes = {
    prefix: "dokumentit",
    routes: tyoluvatRoutes,
    template: lazy(() => import(/* webpackChunkName: 'DokumentitApp' */"./DokumentitApp")),
    routeId: DokumentitRouteId
}

export default DokumentitRouting